<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<table>
			<tr>
				<td>{{ $t('getapi[2524]') }}</td>
				<td>
					<el-date-picker v-model="edata" size="mini" type="date" :placeholder="$t('getapi[6428]')"
									@change="changed"></el-date-picker>
				</td>
				<td>
					<el-button type="primary" size="mini" @click="intidata" :loading="loading" :disabled="loading">
						{{ $t('getapi[2530]') }}
					</el-button>
				</td>
			</tr>
		</table>
				<el-table
					id="xpane-0"
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					style="width: 100%; margin-top:0px"
					ref="singleTable"
				>
					<el-table-column type="selection" v-if="false"></el-table-column>
					<el-table-column prop="inv_end_date" :label="$t('getapi[2513]')">
						<template slot-scope="scope">
							{{scope.row.inv_end_date|timeFormat}}
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="sequence_no" align="right" :label="$t('getapi[1764]')"></el-table-column>
					<el-table-column prop="qty" align="right" :label="$t('getapi[2234]')">
						<template slot-scope="scope">
							{{scope.row.qty | thousandth}}
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip prop="category_first_name" :label="$t('getapi[169]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="category_second_name" :label="$t('getapi[170]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="category_third_name" :label="$t('getapi[171]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="stockin_time" :label="$t('getapi[2101]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="inv_day" :label="$t('getapi[2514]')" align="right"></el-table-column>
					<!-- <el-table-column show-overflow-tooltip prop="inv_unit" :label="$t('getapi[2516]')" align="right"></el-table-column> -->
					<!-- <el-table-column prop="inv_amount" align="right" :label="$t('getapi[2517]')">
						<template slot-scope="scope">
							{{scope.row.inv_amount | thousandth}}
						</template>
					</el-table-column> -->
					<!-- <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column> -->
					<!-- <el-table-column show-overflow-tooltip prop="issue_time" :label="$t('getapi[2179]')"></el-table-column> -->
					<el-table-column show-overflow-tooltip prop="client_code" :label="$t('getapi[2610]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="year_interval" :label="$t('getapi[12610]')"></el-table-column>
				</el-table>
			<!-- </el-tab-pane> -->
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<serce :isVisible="isVisible" queryData="InvAgingInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'InvAgingForwardViewNew',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3 - Common.reduceTableHeight2
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('InvAgingForwardViewNew'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
            scrollTop:0,
            sdata: '',
            edata: '',
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[13137]"),this.$t("getapi[15]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			if (that.total > 0) {
				that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			} else {
				that.$refs.SetBtn.SetButtonEnable('search,refresh');
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('InvAgingForwardViewNew',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'InvAgingForwardViewNew');
		},
		//获取查询条件
		serclick(val) {
			console.log(val);
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			console.log(data);
			that.$http.urlpost('/Inv/Manager/InvAgingForwardView_New', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				
				that.authority();
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac,
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[984]')
			};
			that.$http.urlpost('/Inv/Manager/InvAgingForwardNewExportExcel', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
        //获取时间
        changed(e) {
            console.log(e);
            var dd = new Date(e);
            this.edata = this.getday(e);
            dd.setDate(dd.getDate() - 180); //获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
            this.sdata = y + '-' + m + '-' + d;
        },
        //获取时分秒
        gethfm() {
            var myDate = new Date();
            let h = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours(); //获取系统时，
            let m = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes(); //分
            let s = myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds(); //秒
            return h + ':' + m + ':' + s;
        },
        //获取年月日
        getday(e) {
            var dd = new Date(e);
            var ye = dd.getFullYear();
            var me = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
            var de = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
            return ye + '-' + me + '-' + de;
        },
        intidata() {
            let that = this;
            that.loading = true;
            let newd = that.getday(new Date());
            if (that.edata) {
                if (newd == that.edata) {
                    that.$message.error(that.$t('getapi[2536]'));
                    that.loading = false;
                } else {
                    that.stime = that.gethfm();
                    that.etime = '';
                    let parm = {
                        isbegintimevisible: true,
                        begintime: that.sdata,
                        endtime: that.edata
                    };
                    that.$http.urlpost('Inv/Manager/OnhandStockAge_New', parm, function (res) {
                        that.etime = that.gethfm();
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                        that.loading = false;
                    });
                }
            } else {
                that.$message.error(that.$t('getapi[4102]'));
                that.loading = false;
            }
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
